import React, { useMemo } from 'react';
import {
  Box,
  Avatar,
  Typography,
  useTheme,
  IconButton,
  Tooltip,
  Chip,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import {
  Download,
  WhatsApp,
  // Visibility,
} from '@mui/icons-material';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
  type MRT_PaginationState,
} from 'material-react-table';
import { applicationsService, MyApplication } from '@/services/applications/applicationsService';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
// import DOMPurify from 'dompurify';
import { useDispatch,  } from 'react-redux';
import { AppDispatch,  } from '@/store/types';
import { updateApplicationStatus } from '@/store';
import { useAuth } from '@/hooks';
interface MyApplicationsTableProps {
  applications: MyApplication[];
  loading?: boolean;
  totalCount?: number;
  pagination?: MRT_PaginationState;
  onPaginationChange?: (pagination: MRT_PaginationState) => void;
  feedType: 'job' | 'jobseeker';
}

export const MyApplicationsTable: React.FC<MyApplicationsTableProps> = ({
  applications,
  loading = false,
  totalCount,
  pagination = { pageIndex: 0, pageSize: 10 },
  onPaginationChange,
  feedType,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
    const { user } = useAuth();
  const handleDownloadResume = (resumeUrl: string) => {
    window.open(resumeUrl, '_blank', 'noopener,noreferrer');
  };

  const handleWhatsAppChat = (whatsappNumber: string) => {
    if (whatsappNumber) {
      const cleanNumber = whatsappNumber.replace(/[^\d]/g, '');
      const url = `https://web.whatsapp.com/send?phone=${cleanNumber}&text=Hi👋`;
      window.open(url, '_blank');
    }
  };
  
 const handleStatusChange = async (applicationId: string, userId: string, newStatus: string, feedId:string, feed:MyApplication) => {
    console.log('handleStatusChange called:', { applicationId, userId, newStatus, feedId });
    console.log(feed?.jobSeekerDetails?._id)
    if (!feedId) {
      console.error('feedId is required for status update');
      return;
    }
    
    try {
      console.log('Making API call to update status...');
      const result = await applicationsService.updateApplicationStatus(feedId, user?.id!, newStatus as any);
      console.log('Status update result:', result);
      
      // Update the Redux state via callback
      // onStatusUpdate?.(applicationId, newStatus);
        dispatch(updateApplicationStatus({ applicationId, status: newStatus }));
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  // const handleViewFeed = (feedId: string) => {
  //   navigate(`/talky?feedId=${feedId}`);
  // };

  // const stripHtml = (html: string) => {
  //   const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
  //   return clean.substring(0, 100) + (clean.length > 100 ? '...' : '');
  // };

  const columns = useMemo<MRT_ColumnDef<MyApplication>[]>(
    () => {
      const baseColumns: MRT_ColumnDef<MyApplication>[] = [
        {
          id: 'post',
          header: feedType === 'job' ? 'Job Post' : 'Job Seeker',
          size: 300,
          enableSorting: false,
          Cell: ({ row }) => {
            const feed = row.original.feedId;
            const poster = feed.userId;

            return (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }} onClick={()=> navigate(`/profile/${poster._id}`)}>
                  <Avatar
                    src={poster.profilePictureId?.url}
                    sx={{ width: 32, height: 32 }}
                  >
                    {poster.name?.charAt(0) || 'U'}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      {poster.name}
                    </Typography>
                    {/* <Typography variant="caption" color="text.secondary">
                      Posted by {poster.name}
                    </Typography> */}
                  </Box>
                </Box>
                {/* <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                  {stripHtml(feed.content)}
                </Typography> */}
              </Box>
            );
          },
        },
      ];

      if (feedType === 'job') {
        baseColumns.push(
          {
            id: 'jobDetails',
            header: 'Job Details',
            size: 200,
            enableSorting: false,
            Cell: ({ row }) => {
              const jobDetails = row.original.jobDetails;
              if (!jobDetails) return <Typography variant="body2">-</Typography>;

              return (
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {jobDetails.jobTitle}
                  </Typography>
                  {/* <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                    <Chip
                      label={jobDetails.jobType}
                      size="small"
                      variant="outlined"
                      sx={{ height: 20, fontSize: '0.7rem' }}
                    />
                    <Chip
                      label={jobDetails.experienceLevel}
                      size="small"
                      variant="outlined"
                      sx={{ height: 20, fontSize: '0.7rem' }}
                    />
                    <Chip
                      label={jobDetails.workMode}
                      size="small"
                      variant="outlined"
                      sx={{ height: 20, fontSize: '0.7rem' }}
                    />
                  </Box> */}
                  {jobDetails.location && jobDetails.location.length > 0 && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                      {jobDetails.location.join(', ')}
                    </Typography>
                  )}
                </Box>
              );
            },
          },
          {
            id: 'deadline',
            header: 'Deadline',
            size: 120,
            enableSorting: false,
            Cell: ({ row }) => {
              const jobDetails = row.original.jobDetails;
              if (!jobDetails?.applicationDeadline) {
                return <Typography variant="body2">-</Typography>;
              }

              return (
                <Box>
                  <Typography variant="body2">
                    {moment(jobDetails.applicationDeadline).format('MMM DD, YYYY')}
                  </Typography>
                  {jobDetails.isDeadlinePassed ? (
                    <Chip label="Expired" size="small" color="error" sx={{ mt: 0.5 }} />
                  ) : (
                    <Typography variant="caption" color="success.main">
                      {jobDetails.daysRemaining} days left
                    </Typography>
                  )}
                </Box>
              );
            },
          }
        );
      } else {
        baseColumns.push(
          {
            id: 'jobTitle',
            header: 'Title',
            size: 200,
            enableSorting: false,
            Cell: ({ row }) => {
              const feed = row.original.feedId;
              return (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {feed.title || 'Job Seeker Profile'}
                </Typography>
              );
            },
          },
          {
            id: 'seekerDetails',
            header: 'Skills & Location',
            size: 250,
            enableSorting: false,
            Cell: ({ row }) => {
              const seekerDetails = row.original.jobSeekerDetails;
              if (!seekerDetails) return <Typography variant="body2">-</Typography>;

              return (
                <Box>
                  {seekerDetails.skills && seekerDetails.skills.length > 0 && (
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mb: 1 }}>
                      {seekerDetails.skills.slice(0, 3).map((skill, index) => (
                        <Chip
                          key={index}
                          label={skill}
                          size="small"
                          variant="outlined"
                          sx={{ height: 20, fontSize: '0.7rem' }}
                        />
                      ))}
                      {seekerDetails.skills.length > 3 && (
                        <Chip
                          label={`+${seekerDetails.skills.length - 3}`}
                          size="small"
                          variant="outlined"
                          sx={{ height: 20, fontSize: '0.7rem' }}
                        />
                      )}
                    </Box>
                  )}
                  {seekerDetails.location && seekerDetails.location.length > 0 && (
                    <Typography variant="caption" color="text.secondary">
                      {seekerDetails.location.join(', ')}
                    </Typography>
                  )}
                </Box>
              );
            },
          }
        );
      }

      baseColumns.push(
        {
          id: 'contact',
          header: 'Contact',
          size: 150,
          enableSorting: false,
          Cell: ({ row }) => {
            const poster = row.original.feedId.userId;

            return (
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {poster.name}
                </Typography>
                {poster.whatsappNumber && (
                  <Typography variant="caption" color="text.secondary">
                    {poster.whatsappNumber}
                  </Typography>
                )}
                {poster.currentCompanyInfo?.companyname && (
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    {poster.currentCompanyInfo.companyname}
                  </Typography>
                )}
              </Box>
            );
          },
        },
        {
          id: 'actions',
          header: 'Actions',
          size: 120,
          enableSorting: false,
          Cell: ({ row }) => {
            const poster = row.original.feedId.userId;
            const seekerDetails = row.original.jobSeekerDetails;
            const whatsappNumber = poster.whatsappNumber;
            const resumeUrl = seekerDetails?.resumeId?.url;

            return (
              <Box sx={{ display: 'flex', gap: 1 }}>
                {/* <Tooltip title="View Post">
                  <IconButton
                    size="small"
                    onClick={() => handleViewFeed(row.original.feedId._id)}
                    sx={{
                      color: 'primary.main',
                      '&:hover': {
                        bgcolor: 'primary.lighter',
                      },
                    }}
                  >
                    <Visibility fontSize="small" />
                  </IconButton>
                </Tooltip> */}
                {resumeUrl && feedType === 'jobseeker' && (
                  <Tooltip title="Download Resume">
                    <IconButton
                      size="small"
                      onClick={() => handleDownloadResume(resumeUrl)}
                      sx={{
                        color: 'primary.main',
                        '&:hover': {
                          bgcolor: 'primary.lighter',
                        },
                      }}
                    >
                      <Download fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
                {whatsappNumber && (
                  <Tooltip title="Chat on WhatsApp">
                    <IconButton
                      size="small"
                      onClick={() => handleWhatsAppChat(whatsappNumber)}
                      sx={{
                        color: '#25D366',
                        '&:hover': {
                          bgcolor: 'rgba(37, 211, 102, 0.1)',
                        },
                      }}
                    >
                      <WhatsApp fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            );
          },
        },
         {
                id: 'status',
                header: 'Status rec',
                size: 150,
                enableSorting: false,
                Cell: ({ row }) => {
                  const currentStatus = row.original.status || 'Pending';
                  const userId = row.original.userId._id;
                  const applicationId = row.original._id;
                  const feed_id = row.original.feedId._id;
                  const isJobSeeker = row.original.feedId.feedType.name === 'jobSeeker';

                  const statusColorMap = {
                    'Pending': 'default',
                    'Under review': 'info',
                    'Shortlisted': 'success',
                    'Rejected': 'error',
                  } as const;

                  if (!isJobSeeker) {
                    return (
                      <Chip
                        label={currentStatus}
                        color={statusColorMap[currentStatus as keyof typeof statusColorMap] || 'default'}
                        size="small"
                      />
                    );
                  }

                  return (
                    <FormControl size="small" fullWidth>
                      <Select
                        value={currentStatus}
                        onChange={(e) => handleStatusChange(applicationId, userId, e.target.value, feed_id, row?.original)}
                        sx={{
                          minWidth: 120,
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          }
                        }}
                      >
                        <MenuItem value="Pending">
                          <Chip label="Pending" color="default" size="small" />
                        </MenuItem>
                        <MenuItem value="Under review">
                          <Chip label="Under review" color="info" size="small" />
                        </MenuItem>
                        <MenuItem value="Shortlisted">
                          <Chip label="Shortlisted" color="success" size="small" />
                        </MenuItem>
                        <MenuItem value="Rejected">
                          <Chip label="Rejected" color="error" size="small" />
                        </MenuItem>
                      </Select>
                    </FormControl>
                  );
                },
              },
        // {
        //   id: 'status',
        //   header: 'Status 12',
        //   size: 130,
        //   enableSorting: false,
        //   Cell: ({ row }) => {
        //     const status = row.original.status || 'Pending';
        //     const colorMap = {
        //       'Pending': 'default',
        //       'Under review': 'info',
        //       'Shortlisted': 'success',
        //       'Rejected': 'error',
        //     } as const;

        //     return (
        //       <Chip
        //         label={status}
        //         color={colorMap[status] || 'default'}
        //         size="small"
        //       />
        //     );
        //   },
        // },
        {
          accessorKey: 'appliedAt',
          header: 'Applied Date',
          size: 130,
          enableSorting: true,
          sortingFn: 'datetime',
          Cell: ({ cell }) => (
            <Box>
              <Typography variant="body2">
                {moment(cell.getValue() as string).format('MMM DD, YYYY')}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {moment(cell.getValue() as string).fromNow()}
              </Typography>
            </Box>
          ),
        }
      );

      return baseColumns;
    },
    [feedType]
  );

  const defaultTableOptions: Partial<MRT_TableOptions<MyApplication>> = {
    columns,
    data: applications,
    enableRowSelection: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enablePagination: true,
    enableSorting: true,
    enableBottomToolbar: true,
    enableTopToolbar: false,
    muiTableBodyRowProps: {
      sx: {
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        border: 'none',
      },
    },
    muiTableProps: {
      sx: {
        tableLayout: 'fixed',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        fontWeight: 600,
        backgroundColor: theme.palette.grey[50],
        borderBottom: `2px solid ${theme.palette.divider}`,
      },
    },
    state: {
      isLoading: loading,
      pagination,
    },
    onPaginationChange: (updaterOrValue: any) => {
      if (onPaginationChange) {
        if (typeof updaterOrValue === 'function') {
          const newPagination = updaterOrValue(pagination);
          onPaginationChange(newPagination);
        } else {
          onPaginationChange(updaterOrValue);
        }
      }
    },
    rowCount: totalCount,
    manualPagination: !!onPaginationChange,
  };

  const table = useMaterialReactTable(defaultTableOptions as MRT_TableOptions<MyApplication>);

  return <MaterialReactTable table={table} />;
};
